// src/data/mockData.js
export const officers = [
  {
    id: 1,
    officerCode: 'OFF001',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@dept.gov',
    mobile: '+1-555-0101',
    status: 'active',
    joinDate: '2024-01-15',
    lastScan: '2024-03-20 14:30',
    totalScans: 1247,
    avatar: 'JS',
    department: 'Security',
    shift: 'Morning',
    permissions: ['scan', 'report_view']
  },
  {
    id: 2,
    officerCode: 'OFF002',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.johnson@dept.gov',
    mobile: '+1-555-0102',
    status: 'active',
    joinDate: '2024-02-01',
    lastScan: '2024-03-20 16:45',
    totalScans: 892,
    avatar: 'SJ',
    department: 'Patrol',
    shift: 'Evening',
    permissions: ['scan', 'report_view', 'officer_manage']
  },
  {
    id: 3,
    officerCode: 'OFF003',
    firstName: 'Michael',
    lastName: 'Brown',
    email: 'michael.brown@dept.gov',
    mobile: '+1-555-0103',
    status: 'inactive',
    joinDate: '2024-01-08',
    lastScan: '2024-03-15 09:15',
    totalScans: 634,
    avatar: 'MB',
    department: 'Investigation',
    shift: 'Night',
    permissions: ['scan', 'report_view']
  },
  {
    id: 4,
    officerCode: 'OFF004',
    firstName: 'Emily',
    lastName: 'Davis',
    email: 'emily.davis@dept.gov',
    mobile: '+1-555-0104',
    status: 'active',
    joinDate: '2024-02-15',
    lastScan: '2024-03-20 18:20',
    totalScans: 1156,
    avatar: 'ED',
    department: 'Security',
    shift: 'Morning',
    permissions: ['scan', 'report_view', 'system_admin']
  }
];

export const scanHistory = [
  {
    id: 1,
    officerCode: 'OFF001',
    officerName: 'John Smith',
    scanType: 'QR Code',
    location: 'Gate A',
    timestamp: '2024-03-20 14:30:22',
    data: 'GATE_A_ENTRY_001',
    status: 'success',
    deviceId: 'SCANNER_001'
  },
  {
    id: 2,
    officerCode: 'OFF002',
    officerName: 'Sarah Johnson',
    scanType: 'Barcode',
    location: 'Checkpoint B',
    timestamp: '2024-03-20 16:45:10',
    data: 'CHK_B_VEHICLE_789',
    status: 'success',
    deviceId: 'SCANNER_002'
  },
  {
    id: 3,
    officerCode: 'OFF001',
    officerName: 'John Smith',
    scanType: 'QR Code',
    location: 'Gate C',
    timestamp: '2024-03-20 13:15:45',
    data: 'GATE_C_EXIT_002',
    status: 'success',
    deviceId: 'SCANNER_003'
  },
  {
    id: 4,
    officerCode: 'OFF004',
    officerName: 'Emily Davis',
    scanType: 'QR Code',
    location: 'Main Entrance',
    timestamp: '2024-03-20 18:20:15',
    data: 'MAIN_ENT_VIP_005',
    status: 'failed',
    deviceId: 'SCANNER_001',
    errorMessage: 'Invalid QR code format'
  },
  {
    id: 5,
    officerCode: 'OFF003',
    officerName: 'Michael Brown',
    scanType: 'Barcode',
    location: 'Storage Area',
    timestamp: '2024-03-20 12:05:30',
    data: 'STORE_ITEM_445',
    status: 'success',
    deviceId: 'SCANNER_004'
  }
];

export const notifications = [
  {
    id: 1,
    title: 'New officer registered',
    message: 'Emily Davis has been added to the system',
    time: '2 min ago',
    type: 'info',
    read: false,
    priority: 'normal'
  },
  {
    id: 2,
    title: 'Suspicious scan activity',
    message: 'Multiple failed scans detected at Gate A',
    time: '5 min ago',
    type: 'warning',
    read: false,
    priority: 'high'
  },
  {
    id: 3,
    title: 'Daily report ready',
    message: 'March 20, 2024 daily report is available for download',
    time: '1 hour ago',
    type: 'success',
    read: true,
    priority: 'low'
  },
  {
    id: 4,
    title: 'System maintenance',
    message: 'Scheduled maintenance will begin at midnight',
    time: '2 hours ago',
    type: 'info',
    read: false,
    priority: 'normal'
  }
];

export const dashboardStats = {
  totalOfficers: officers.length,
  activeOfficers: officers.filter(o => o.status === 'active').length,
  totalScans: officers.reduce((sum, officer) => sum + officer.totalScans, 0),
  todayScans: scanHistory.length,
  successRate: 95.2,
  averageScansPerOfficer: Math.round(officers.reduce((sum, officer) => sum + officer.totalScans, 0) / officers.length),
  topPerformer: officers.sort((a, b) => b.totalScans - a.totalScans)[0],
  recentActivity: scanHistory.slice(0, 5),
  monthlyGrowth: {
    officers: 15.2,
    scans: 23.8,
    efficiency: 8.4
  }
};

export const departments = [
  'Security',
  'Patrol',
  'Investigation',
  'Administration',
  'Maintenance',
  'Emergency Response'
];

export const shifts = [
  'Morning',
  'Evening', 
  'Night'
];

export const permissions = [
  { id: 'scan', label: 'Scan Operations', description: 'Perform QR/Barcode scanning' },
  { id: 'report_view', label: 'View Reports', description: 'Access system reports' },
  { id: 'officer_manage', label: 'Manage Officers', description: 'Create and edit officer profiles' },
  { id: 'system_admin', label: 'System Admin', description: 'Full system administration access' },
  { id: 'export_data', label: 'Export Data', description: 'Export reports and data' }
];